import script from "./ProfileAddModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileAddModal.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileAddModal.vue?vue&type=style&index=0&id=5cc7a613&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc7a613"]])

export default __exports__